import axios from "axios";
import { decryptData, encryptData } from "../helpers/encryptionUtils";
import { authServices } from "../Redux/services/auth.services";
import { setUserDetails } from "../Redux/reducers/authSlice";
import { showToast } from "../Redux/reducers/toastSlice";

export const setupAxiosInterceptors = async (userDetails, navigate, dispatch) => {
  if (!userDetails?.Token) {
    delete axios.defaults.headers.common.Authorization;
    axios.interceptors.request.eject(axios.interceptors.request.handlers[0]);
    axios.interceptors.response.eject(axios.interceptors.response.handlers[0]);

    return;
  }

  const { Token, UserId, SessionId } = userDetails;
  let isLogoutInProgress = false;

  axios.defaults.headers.common.Authorization = `Bearer ${Token}`;

  const handleRequestSuccess = (config) => config;

  const handleRequestError = (error) => Promise.reject(error);

  const handleResponseSuccess = (response) => response;

  const handleResponseError = async (error) => {
    const originalRequest = error.config;

    if (error?.response?.status === 401) {
      if (originalRequest._retry) {
        return Promise.reject(error);
      }

      if (error?.response?.data?.error === "jwtExpired") {
        originalRequest._retry = true;

        try {
          const tokenData = { token: Token };
          const refreshTokenResponse = await authServices.getRefreshToken(tokenData);
          const newToken = refreshTokenResponse?.data?.ResponseObject?.Token;

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          const updatedUserDetails = { ...userDetails, Token: newToken };

          axios.defaults.headers.common.Authorization = `Bearer ${newToken}`;
          localStorage.setItem(
            "kitapUser",
            JSON.stringify(encryptData(JSON.stringify(updatedUserDetails))?.encryptedData),
          );
          dispatch(setUserDetails(updatedUserDetails));

          return axios(originalRequest);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }

      if (!isLogoutInProgress) {
        isLogoutInProgress = true;

        try {
          await authServices.logout({ UserId, SessionId });
          localStorage.removeItem("kitapUser");
          dispatch(setUserDetails({}));

          navigate("/login");
        } catch (logoutError) {
          dispatch(showToast({ message: logoutError?.response?.data?.message || logoutError.message, type: "error" }));
        }
      }
    }

    if (error?.response?.status === 402 && !isLogoutInProgress) {
      isLogoutInProgress = true;

      try {
        const decryptedData = await decryptData(error.response.data);
        navigate(`/license/${decryptedData?.ExpiryType}`);
      } catch (decryptionError) {
        dispatch(
          showToast({ message: decryptionError?.response?.data?.message || decryptionError.message, type: "error" }),
        );
      }
    }

    return Promise.reject(error);
  };

  axios.interceptors.request.use(handleRequestSuccess, handleRequestError);
  axios.interceptors.response.use(handleResponseSuccess, handleResponseError);
};
